import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable'
import Home from './home/home';
import Contact from './contact/contact';

const Loading = () => <div>Loading...</div>;

const Portfolio = Loadable({
    loader: () => import('./portfolio/portfolio'),
    loading: Loading,
});

const WebApp = Loadable({
    loader: () => import('./webapp/webapp'),
    loading: Loading,
});
const Gallery = Loadable({
    loader: () => import('./gallery/gallery'),
    loading: Loading,
});

 const Router = () => (
     <Switch>
        <Route exact path="/"  component={Home} />
        <Route path="/webapp" component={WebApp}/>
        <Route path="/portfolio" component={Portfolio}/>
        <Route path="/contact" component={Contact} />
        <Route path="/gallery" component={Gallery} />
        <Route path="/:id" render = {()=> (<p> Page not found 404 </p>)}/>
     </Switch>
  )

  export default Router;


// WEBPACK FOOTER //
// ./src/component/router.js